Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var core = require('@material-ui/core');
var dateFns = require('date-fns');
var clsx = require('clsx');
var FullCalendar = require('@fullcalendar/react');
var locale = require('@fullcalendar/core/locales/en-gb');
var interactionPlugin = require('@fullcalendar/interaction');
var timeGridPlugin = require('@fullcalendar/timegrid');
var reactFeather = require('react-feather');
var models = require('@ds-developer/models');
var Label = require('@ds-developer/label');
var MapLink = require('@ds-developer/map-link');
var constants = require('@ds-developer/constants');
var ViewDayOutlined = require('@material-ui/icons/ViewDayOutlined');
var ViewModuleOutlined = require('@material-ui/icons/ViewModuleOutlined');
var ViewWeekOutlined = require('@material-ui/icons/ViewWeekOutlined');
var frontend = require('@ds-developer/frontend');
var pickers = require('@material-ui/pickers');
var Button = require('@ds-developer/button');
var ViewComfyOutlined = require('@material-ui/icons/ViewComfyOutlined');
var _ = require('lodash');
var memoize = require('memoize-one');
var reactWindow = require('react-window');
var styles = require('@material-ui/core/styles');
var NavigateBeforeIcon = require('@material-ui/icons/NavigateBefore');
var NavigateNextIcon = require('@material-ui/icons/NavigateNext');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var FullCalendar__default = /*#__PURE__*/_interopDefaultLegacy(FullCalendar);
var locale__default = /*#__PURE__*/_interopDefaultLegacy(locale);
var interactionPlugin__default = /*#__PURE__*/_interopDefaultLegacy(interactionPlugin);
var timeGridPlugin__default = /*#__PURE__*/_interopDefaultLegacy(timeGridPlugin);
var Label__default = /*#__PURE__*/_interopDefaultLegacy(Label);
var MapLink__default = /*#__PURE__*/_interopDefaultLegacy(MapLink);
var ViewDayOutlined__default = /*#__PURE__*/_interopDefaultLegacy(ViewDayOutlined);
var ViewModuleOutlined__default = /*#__PURE__*/_interopDefaultLegacy(ViewModuleOutlined);
var ViewWeekOutlined__default = /*#__PURE__*/_interopDefaultLegacy(ViewWeekOutlined);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var ViewComfyOutlined__default = /*#__PURE__*/_interopDefaultLegacy(ViewComfyOutlined);
var ___default = /*#__PURE__*/_interopDefaultLegacy(_);
var memoize__default = /*#__PURE__*/_interopDefaultLegacy(memoize);
var NavigateBeforeIcon__default = /*#__PURE__*/_interopDefaultLegacy(NavigateBeforeIcon);
var NavigateNextIcon__default = /*#__PURE__*/_interopDefaultLegacy(NavigateNextIcon);
var useStyles = core.makeStyles(function (theme) {
  return {
    dayOfMonth: {
      color: core.colors.blueGrey[200],
      textTransform: "uppercase",
      fontSize: "12px",
      lineHeight: "12px"
    },
    dayOfWeek: function dayOfWeek(_a) {
      var isToday = _a.isToday,
        notWorked = _a.notWorked;
      return {
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: theme.typography.fontWeightMedium,
        color: isToday ? core.colors.blue[500] : core.colors.blueGrey[900],
        opacity: notWorked ? 0.5 : 1
      };
    },
    currentDayIndicatorWrapper: {
      textAlign: "center"
    },
    currentDayIndicator: {
      height: "4px",
      width: "6px",
      backgroundColor: theme.palette.secondary.main,
      borderRadius: "2px",
      margin: "auto"
    }
  };
});
var DayHeader = function DayHeader(_a) {
  var isToday = _a.isToday,
    date = _a.date,
    dow = _a.dow,
    workingDays = _a.workingDays;
  var notWorked = !workingDays.includes(dow);
  var classes = useStyles({
    isToday: isToday,
    notWorked: notWorked
  });
  return React__default['default'].createElement(core.Box, {
    textAlign: "center",
    padding: 1,
    paddingBottom: 3,
    "data-test": "calendar-day-header"
  }, React__default['default'].createElement(core.Typography, {
    classes: {
      root: classes.dayOfMonth
    }
  }, dateFns.format(date, "ccc")), React__default['default'].createElement(core.Typography, {
    classes: {
      root: classes.dayOfWeek
    }
  }, dateFns.format(date, "d")), isToday && React__default['default'].createElement("div", {
    className: classes.currentDayIndicator,
    "data-test": "calendar-current-day-indicator"
  }));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
(function (CalendarView) {
  CalendarView["day"] = "DAY";
  CalendarView["threeDay"] = "THREE_DAY";
  CalendarView["week"] = "WEEK";
  CalendarView["month"] = "MONTH";
})(exports.CalendarView || (exports.CalendarView = {}));
var getContentPaddingValues = function getContentPaddingValues(eventSize, quarterHoursSpanned, theme, breakpoint) {
  if (breakpoint === void 0) {
    breakpoint = "xs";
  }
  var isShortEvent = quarterHoursSpanned <= 4;
  var isLargeEventSize = eventSize === "lg";
  var isSmallEventSize = eventSize === "sm";
  switch (breakpoint) {
    case "sm":
      {
        if (isShortEvent) {
          return isLargeEventSize ? theme.spacing(0.5, 0.5, 0.5, 3) : theme.spacing(0.5, 1);
        }
        return isLargeEventSize ? theme.spacing(0.5, 0.5, 0.5, 2) : theme.spacing(0.5, 1);
      }
    case "md":
      {
        if (isShortEvent) {
          return isLargeEventSize ? theme.spacing(0.5, 0.5, 0.5, 3) : theme.spacing(0.5, 1);
        }
        return isLargeEventSize ? theme.spacing(2, 0.5, 1, 2) : theme.spacing(0.5, 1);
      }
    default:
      {
        if (isSmallEventSize) {
          return theme.spacing(0.5);
        }
        if (isShortEvent) {
          return isLargeEventSize ? theme.spacing(0.5, 0.5, 0.5, 2) : theme.spacing(0.5, 1);
        }
        return isLargeEventSize ? theme.spacing(2, 0.5, 0.5, 2) : theme.spacing(0.5, 1);
      }
  }
};
var useStyles$1 = core.makeStyles(function (theme) {
  var _a, _b, _c, _d, _e;
  return _a = {
    fillHeight: {},
    contentWrapper: (_b = {
      height: "100%",
      alignItems: function alignItems(_a) {
        var size = _a.size,
          quarterHoursSpanned = _a.quarterHoursSpanned;
        return size === "lg" && quarterHoursSpanned <= 4 ? "center" : "flex-start";
      },
      padding: function padding(_a) {
        var size = _a.size,
          quarterHoursSpanned = _a.quarterHoursSpanned;
        return getContentPaddingValues(size, quarterHoursSpanned, theme);
      }
    }, _b[theme.breakpoints.up("sm")] = {
      padding: function padding(_a) {
        var size = _a.size,
          quarterHoursSpanned = _a.quarterHoursSpanned;
        return getContentPaddingValues(size, quarterHoursSpanned, theme, "sm");
      }
    }, _b[theme.breakpoints.up("md")] = {
      padding: function padding(_a) {
        var size = _a.size,
          quarterHoursSpanned = _a.quarterHoursSpanned;
        return getContentPaddingValues(size, quarterHoursSpanned, theme, "md");
      }
    }, _b),
    arrowWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      height: "100%"
    },
    event: function event(_a) {
      var _b;
      var eventType = _a.eventType,
        size = _a.size;
      var eventColors = constants.EVENT_COLORS[eventType];
      return _assign({
        cursor: "pointer",
        background: eventColors.background,
        color: core.colors.blueGrey[900],
        borderLeft: "4px solid " + eventColors.highlight,
        borderRadius: "4px",
        height: "100%",
        boxSizing: "border-box"
      }, size === "lg" ? (_b = {}, _b[theme.breakpoints.up("sm")] = {
        marginLeft: size == "lg" ? theme.spacing(4) : 0
      }, _b) : {});
    }
  }, _a["event-" + models.EventType.Travel] = {
    border: 0
  }, _a.titleWrapper = {
    overflow: "hidden"
  }, _a.title = (_c = {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: function fontSize(_a) {
      var size = _a.size;
      return size === "lg" ? "1rem" : size === "sm" ? "0.75rem" : "0.875rem";
    }
  }, _c[theme.breakpoints.up("md")] = {
    fontSize: function fontSize(_a) {
      var size = _a.size;
      return size === "lg" ? "1rem" : "0.875rem";
    }
  }, _c), _a.learnerFullNameContainer = {
    maxWidth: "100%"
  }, _a.learnerFullName = (_d = {
    overflow: "hidden",
    margin: function margin(_a) {
      var size = _a.size;
      return size === "lg" ? theme.spacing(0, 3) : 0;
    },
    fontSize: function fontSize(_a) {
      var viewType = _a.viewType;
      var fs = "10px";
      if (viewType === exports.CalendarView.day) fs = "16px";
      if (viewType === exports.CalendarView.threeDay) fs = "12px";
      return fs;
    },
    lineHeight: function lineHeight(_a) {
      var viewType = _a.viewType;
      var fs = "10px";
      if (viewType === exports.CalendarView.day) fs = "24px";
      if (viewType === exports.CalendarView.threeDay) fs = "12px";
      return fs;
    },
    letterSpacing: "0.4px"
  }, _d[theme.breakpoints.up("md")] = {
    fontSize: function fontSize(_a) {
      var viewType = _a.viewType;
      return viewType === exports.CalendarView.day ? "16px" : "12px";
    },
    lineHeight: function lineHeight(_a) {
      var viewType = _a.viewType;
      return viewType === exports.CalendarView.day ? "24px" : "12px";
    }
  }, _d), _a.address = (_e = {
    color: core.colors.blueGrey[600],
    marginTop: function marginTop(_a) {
      var quarterHoursSpanned = _a.quarterHoursSpanned;
      return quarterHoursSpanned <= 4 ? 0 : theme.spacing(0.5);
    },
    lineHeight: function lineHeight(_a) {
      var viewType = _a.viewType;
      var fs = "10px";
      if (viewType === exports.CalendarView.day) fs = "22px";
      if (viewType === exports.CalendarView.threeDay) fs = "12px";
      return fs;
    },
    fontSize: function fontSize(_a) {
      var viewType = _a.viewType;
      var fs = "10px";
      if (viewType === exports.CalendarView.day) fs = "14px";
      if (viewType === exports.CalendarView.threeDay) fs = "12px";
      return fs;
    }
  }, _e[theme.breakpoints.up("md")] = {
    lineHeight: function lineHeight(_a) {
      var viewType = _a.viewType;
      return viewType === exports.CalendarView.day ? "22px" : " 12px";
    },
    fontSize: function fontSize(_a) {
      var viewType = _a.viewType;
      return viewType === exports.CalendarView.day ? "14px" : "12px";
    }
  }, _e), _a.chevron = {
    color: core.colors.blueGrey[900]
  }, _a;
});
var Event$1 = function Event$1(_a) {
  var _b = _a.event,
    title = _b.title,
    start = _b.start,
    end = _b.end,
    extendedProps = _b.extendedProps,
    _c = _a.size,
    size = _c === void 0 ? "lg" : _c,
    _d = _a.viewType,
    viewType = _d === void 0 ? exports.CalendarView.day : _d;
  var id = extendedProps.id,
    eventType = extendedProps.eventType,
    learnerFullName = extendedProps.learnerFullName,
    _e = extendedProps.address,
    address = _e === void 0 ? {} : _e;
  var quarterHoursSpanned = (end && start ? dateFns.differenceInMinutes(end, start) : 0) / 15;
  var theme = core.useTheme();
  var classes = useStyles$1({
    eventType: eventType,
    size: size,
    quarterHoursSpanned: quarterHoursSpanned,
    viewType: viewType
  });
  var isSmScreen = core.useMediaQuery(theme.breakpoints.down("sm"), {
    defaultMatches: true
  });
  var showAddress = viewType === exports.CalendarView.day && quarterHoursSpanned > 4 || !isSmScreen;
  var showMapLink = viewType === exports.CalendarView.day && quarterHoursSpanned > 4 || !isSmScreen;
  var showExtendedAddress = !isSmScreen && quarterHoursSpanned >= 10 && viewType === exports.CalendarView.week;
  var displayContent = eventType !== models.EventType.Travel;
  // Show the SS (self-sourced) label if ...
  var showSSLabel = extendedProps.learnerSource === "Instructor";
  var showTestLabel = extendedProps.test;
  // show the new label if...
  var showNewLabel =
  // it's a NewLesson event, it's displaying on desktop and the event is longer
  // than 1 hour (any less and there's not enough room for it)
  eventType === models.EventType.NewLesson && !isSmScreen && quarterHoursSpanned > 4 ||
  // or it's a NewLesson event, it's displaying on mobile and we're showing the day view.
  // All other mobile views render events too small to fit the "new" label in
  eventType === models.EventType.NewLesson && isSmScreen && quarterHoursSpanned > 4 && viewType === exports.CalendarView.day;
  return React__default['default'].createElement(core.Box, {
    "data-test": "event-" + id,
    className: clsx__default['default'](classes.event, classes["event-" + eventType], "event-" + eventType)
  }, displayContent && React__default['default'].createElement(core.Grid, {
    container: true,
    spacing: 0,
    classes: {
      root: classes.contentWrapper
    }
  }, React__default['default'].createElement(core.Grid, {
    item: true,
    xs: size === "lg" ? 10 : 12,
    lg: size === "lg" ? 11 : 12
  }, React__default['default'].createElement(core.Grid, {
    container: true,
    alignItems: "center",
    wrap: size === "lg" ? "nowrap" : "wrap",
    className: classes.titleWrapper
  }, title && React__default['default'].createElement(core.Grid, {
    item: true,
    xs: size === "lg" ? "auto" : 12
  }, React__default['default'].createElement(core.Typography, {
    "data-test": "event-title",
    classes: {
      root: classes.title
    }
  }, title)), React__default['default'].createElement(core.Grid, {
    item: true,
    xs: size === "lg" ? 10 : 12,
    className: classes.learnerFullNameContainer
  }, React__default['default'].createElement(core.Typography, {
    "data-test": "event-learner-name",
    classes: {
      root: classes.learnerFullName
    }
  }, learnerFullName)), React__default['default'].createElement(core.Grid, {
    container: true,
    spacing: 1,
    alignItems: "center",
    wrap: size === "lg" ? "nowrap" : "wrap"
  }, showNewLabel && React__default['default'].createElement(core.Grid, {
    item: true
  }, React__default['default'].createElement(Label__default['default'], {
    color: "success",
    "data-test": "event-new-label"
  }, "New")), showSSLabel && React__default['default'].createElement(core.Grid, {
    item: true
  }, React__default['default'].createElement(Label__default['default'], {
    color: "ss",
    "data-test": "event-ss-label"
  }, "SS")), showTestLabel && React__default['default'].createElement(core.Grid, {
    item: true
  }, React__default['default'].createElement(Label__default['default'], {
    color: "ss",
    "data-test": "event-test-label"
  }, "Test")))), React__default['default'].createElement(core.Grid, {
    className: classes.address,
    container: true,
    wrap: "nowrap"
  }, React__default['default'].createElement(core.Grid, {
    item: true,
    "data-test": "event-learner-address"
  }, showAddress && React__default['default'].createElement(React.Fragment, null, address.line1 && React__default['default'].createElement(core.Box, null, address.line1), showExtendedAddress && React__default['default'].createElement(React.Fragment, null, address.line2 && React__default['default'].createElement(core.Box, null, address.line2), address.town && React__default['default'].createElement(core.Box, null, address.town))), address.postcode && React__default['default'].createElement(core.Box, null, address.postcode)), showMapLink && address.postcode && React__default['default'].createElement(core.Grid, {
    item: true,
    "data-test": "event-map-link"
  }, React__default['default'].createElement(core.Box, {
    ml: 4
  }, React__default['default'].createElement(MapLink__default['default'], {
    postcode: address.postcode,
    component: "button"
  }))))), size === "lg" && quarterHoursSpanned >= 4 && React__default['default'].createElement(core.Grid, {
    item: true,
    xs: 2,
    lg: 1,
    classes: {
      root: classes.arrowWrapper
    }
  }, React__default['default'].createElement(core.IconButton, null, React__default['default'].createElement(reactFeather.ChevronRight, {
    className: classes.chevron,
    size: 18
  })))));
};
var SlotLabel = function SlotLabel(_a) {
  var text = _a.text;
  return React__default['default'].createElement(React.Fragment, null, text);
};
var useStyles$2 = core.makeStyles(function (theme) {
  var _a;
  return {
    root: (_a = {
      padding: theme.spacing(2, 0, 2, 2),
      paddingBottom: 0,
      opacity: 1,
      transition: "opacity 0.8s"
    }, _a[theme.breakpoints.down("sm")] = {
      padding: theme.spacing(2, 1, 0, 1)
    }, _a),
    singleDay: {
      padding: 0
    },
    loading: {
      opacity: 0.6,
      pointerEvents: "none",
      transition: "opacity 0.1s"
    }
  };
});
var slotLabelFormat = {
  hour: "2-digit",
  hour12: false,
  meridiem: false
};
var slotDurationHours = 1;
var VIEW_TYPES = {
  1: exports.CalendarView.day,
  3: exports.CalendarView.threeDay,
  7: exports.CalendarView.week
};
var DayView = function DayView(_a) {
  var initialDate = _a.initialDate,
    now = _a.now,
    events = _a.events,
    onEventClick = _a.onEventClick,
    onDateClick = _a.onDateClick,
    numberDays = _a.numberDays,
    instructorWorkingDays = _a.instructorWorkingDays,
    loading = _a.loading,
    workingHours = _a.workingHours,
    scrollTime = _a.scrollTime;
  var classes = useStyles$2();
  var theme = core.useTheme();
  var isMobile = core.useMediaQuery(theme.breakpoints.down("sm"));
  var calendarRef = React__default['default'].createRef();
  var showNowIndicator = numberDays === 1;
  var calendarEventSize = numberDays === 1 ? "lg" : numberDays < 4 ? "md" : "sm";
  var viewType = VIEW_TYPES[numberDays];
  var views = {
    default: {
      type: "timeGridWeek",
      duration: {
        days: numberDays
      }
    }
  };
  // Remove inner scrollbar from calendar on mobile only
  var heightProps = {};
  if (isMobile) {
    heightProps.height = "auto";
    heightProps.contentHeight = "auto";
  }
  React.useEffect(function () {
    var _a;
    (_a = calendarRef.current) === null || _a === void 0 ? void 0 : _a.getApi().changeView("default");
    window.dispatchEvent(new Event("resize"));
  }, [numberDays]);
  React.useEffect(function () {
    var _a, _b;
    if (!loading) {
      (_a = calendarRef.current) === null || _a === void 0 ? void 0 : _a.getApi().gotoDate(initialDate);
      (_b = calendarRef.current) === null || _b === void 0 ? void 0 : _b.getApi().setOption("visibleRange", {
        start: initialDate,
        end: dateFns.addDays(initialDate, 3)
      });
    }
  }, [events, loading, initialDate, numberDays]);
  React.useEffect(function () {
    var _a;
    if (scrollTime) {
      (_a = calendarRef.current) === null || _a === void 0 ? void 0 : _a.getApi().scrollToTime(scrollTime);
    }
  }, [scrollTime, numberDays]);
  var getAspectRatio = function getAspectRatio(isMobile, numDays) {
    if (isMobile) {
      return 0.75;
    }
    if (numDays > 3) {
      return 1.35;
    }
    return 1;
  };
  return React__default['default'].createElement(core.Paper, {
    classes: {
      root: clsx__default['default'](classes.root, numberDays === 1 && classes.singleDay, loading && classes.loading)
    }
  }, React__default['default'].createElement(FullCalendar__default['default'], _assign({
    ref: calendarRef,
    viewClassNames: "fc-view-number-days-" + numberDays,
    dayCellClassNames: "fc-day-cell-number-days-" + numberDays,
    initialDate: initialDate,
    now: now,
    views: views,
    initialView: Object.keys(views)[0],
    plugins: [timeGridPlugin__default['default'], interactionPlugin__default['default']],
    slotLabelFormat: slotLabelFormat,
    dayHeaderContent: function dayHeaderContent(props) {
      return React__default['default'].createElement(DayHeader, _assign({}, props, {
        workingDays: instructorWorkingDays
      }));
    },
    slotLabelContent: function slotLabelContent(props) {
      return React__default['default'].createElement(SlotLabel, _assign({}, props));
    },
    eventContent: function eventContent(meta) {
      return React__default['default'].createElement(Event$1, {
        event: meta.event,
        size: calendarEventSize,
        viewType: viewType
      });
    },
    nowIndicator: showNowIndicator,
    events: events,
    locale: locale__default['default'],
    slotDuration: {
      hours: slotDurationHours
    },
    eventClick: onEventClick,
    headerToolbar: false,
    allDaySlot: false,
    dayHeaders: true,
    scrollTime: scrollTime,
    businessHours: workingHours,
    aspectRatio: getAspectRatio(isMobile, numberDays),
    dateClick: onDateClick
  }, heightProps)));
};
var useStyles$3 = core.makeStyles({
  todayButtonWrapper: {
    display: "flex",
    flex: 1,
    gap: 16
  },
  todayButton: {
    borderRadius: 0
  }
});
var DesktopCalendarHeader = function DesktopCalendarHeader(_a) {
  var _b = _a.addEventButtonText,
    addEventButtonText = _b === void 0 ? "Book a lesson" : _b,
    _c = _a.handleTodayClicked,
    handleTodayClicked = _c === void 0 ? function () {} : _c,
    _d = _a.handleViewSelected,
    handleViewSelected = _d === void 0 ? function () {} : _d,
    handleAddEventClicked = _a.handleAddEventClicked,
    _e = _a.showDay,
    showDay = _e === void 0 ? true : _e,
    _f = _a.showThreeDay,
    showThreeDay = _f === void 0 ? true : _f,
    _g = _a.showWeek,
    showWeek = _g === void 0 ? true : _g,
    _h = _a.initialDate,
    initialDate = _h === void 0 ? new Date() : _h,
    _j = _a.selectCalendarInitialDate,
    selectCalendarInitialDate = _j === void 0 ? function () {} : _j;
  var classes = useStyles$3();
  var _k = React.useState(false),
    openDatePicker = _k[0],
    setOpenDatePicker = _k[1];
  return React__default['default'].createElement(pickers.MuiPickersUtilsProvider, {
    utils: frontend.CustomDateFnsUtils
  }, React__default['default'].createElement(core.Grid, {
    container: true,
    spacing: 2,
    direction: "row",
    justify: "flex-end",
    "data-test": "calendar-desktop-header"
  }, React__default['default'].createElement(core.Grid, {
    item: true,
    className: classes.todayButtonWrapper
  }, React__default['default'].createElement(Button__default['default'], {
    onClick: handleTodayClicked,
    variant: "outlined",
    className: classes.todayButton,
    "data-test": "calendar-desktop-header-button-today"
  }, "Today"), React__default['default'].createElement(Button__default['default'], {
    variant: "outlined",
    className: classes.todayButton,
    startIcon: React__default['default'].createElement(reactFeather.Calendar, {
      color: "#546E7A",
      size: 16
    }),
    "data-test": "calendar-desktop-header-button-jump-date",
    onClick: function onClick() {
      return setOpenDatePicker(true);
    }
  }, dateFns.format(initialDate, "MMMM yyyy")), React__default['default'].createElement(pickers.DatePicker, {
    value: initialDate,
    onChange: selectCalendarInitialDate,
    open: openDatePicker,
    onClose: function onClose() {
      return setOpenDatePicker(false);
    },
    style: {
      display: "none"
    }
  })), showDay && React__default['default'].createElement(core.Grid, {
    item: true
  }, React__default['default'].createElement(Button__default['default'], {
    color: "secondary",
    onClick: function onClick() {
      handleViewSelected(exports.CalendarView.day);
    },
    startIcon: React__default['default'].createElement(ViewDayOutlined__default['default'], null),
    variant: "outlined",
    "data-test": "calendar-desktop-header-button-view-day"
  }, "Day")), showThreeDay && React__default['default'].createElement(core.Grid, {
    item: true
  }, React__default['default'].createElement(Button__default['default'], {
    color: "secondary",
    onClick: function onClick() {
      handleViewSelected(exports.CalendarView.threeDay);
    },
    startIcon: React__default['default'].createElement(ViewWeekOutlined__default['default'], null),
    variant: "outlined",
    "data-test": "calendar-desktop-header-button-view-threeDay"
  }, "3 days")), showWeek && React__default['default'].createElement(core.Grid, {
    item: true
  }, React__default['default'].createElement(Button__default['default'], {
    color: "secondary",
    onClick: function onClick() {
      handleViewSelected(exports.CalendarView.week);
    },
    startIcon: React__default['default'].createElement(ViewModuleOutlined__default['default'], null),
    variant: "outlined",
    "data-test": "calendar-desktop-header-button-view-week"
  }, "Week")), handleAddEventClicked && React__default['default'].createElement(core.Grid, {
    item: true
  }, React__default['default'].createElement(Button__default['default'], {
    startIcon: React__default['default'].createElement(reactFeather.PlusCircle, {
      size: 14
    }),
    onClick: handleAddEventClicked,
    color: "primary",
    variant: "contained"
  }, addEventButtonText))));
};
var useStyles$4 = core.makeStyles(function () {
  var _a;
  return _a = {
    key: {
      width: "4px",
      height: "18px"
    }
  }, _a["legend-" + models.EventType.Travel] = {
    background: constants.EVENT_COLORS[models.EventType.Travel].highlight,
    width: "10px"
  }, _a["legend-" + models.EventType.Unavailable] = {
    background: constants.EVENT_COLORS[models.EventType.Unavailable].highlight
  }, _a["legend-" + models.EventType.UnpaidLesson] = {
    background: constants.EVENT_COLORS[models.EventType.UnpaidLesson].highlight
  }, _a["legend-" + models.EventType.NewLesson] = {
    background: constants.EVENT_COLORS[models.EventType.NewLesson].highlight
  }, _a["legend-" + models.EventType.PaidLesson] = {
    background: constants.EVENT_COLORS[models.EventType.PaidLesson].highlight
  }, _a["legend-" + models.EventType.Cancelled] = {
    background: constants.EVENT_COLORS[models.EventType.Cancelled].background
  }, _a.title = {
    color: core.colors.blueGrey[900],
    fontSize: "12px"
  }, _a;
});
var Legend = function Legend(_a) {
  var _b = _a.events,
    events = _b === void 0 ? [] : _b;
  var classes = useStyles$4();
  var types = Array.from(new Set(events.filter(function (_a) {
    var extendedProps = _a.extendedProps;
    return extendedProps === null || extendedProps === void 0 ? void 0 : extendedProps.eventType;
  }).map(function (_a) {
    var extendedProps = _a.extendedProps;
    return extendedProps === null || extendedProps === void 0 ? void 0 : extendedProps.eventType;
  })));
  return React__default['default'].createElement(core.Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    m: 1,
    "data-test": "calendar-legend"
  }, React__default['default'].createElement(core.Grid, {
    container: true,
    spacing: 2,
    justify: "center",
    alignItems: "center"
  }, Object.values(models.EventType).map(function (eventType) {
    return types.includes(eventType) && React__default['default'].createElement(core.Grid, {
      item: true,
      key: "event-type-" + eventType
    }, React__default['default'].createElement(core.Grid, {
      container: true,
      spacing: 1
    }, React__default['default'].createElement(core.Grid, {
      item: true
    }, React__default['default'].createElement("div", {
      className: clsx__default['default'](classes.key, classes["legend-" + eventType])
    })), React__default['default'].createElement(core.Grid, {
      item: true
    }, React__default['default'].createElement(core.Typography, {
      className: classes.title
    }, constants.EVENT_TITLES[eventType]))));
  })));
};
var useStyles$5 = core.makeStyles(function (theme) {
  return {
    button: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      borderRadius: "4px",
      width: "44px",
      height: "44px",
      "&:hover": {
        backgroundColor: theme.palette.secondary.dark
      }
    }
  };
});
var MobileAddButton = function MobileAddButton(props) {
  var classes = useStyles$5();
  return React__default['default'].createElement(core.IconButton, _assign({}, props, {
    className: classes.button
  }), React__default['default'].createElement(reactFeather.Plus, null));
};
var _a;
var useStyles$6 = core.makeStyles(function (theme) {
  return {
    menuButton: {
      border: "1px solid " + theme.palette.secondary.main,
      borderRadius: "4px",
      width: "44px",
      height: "44px"
    }
  };
});
var viewIconMap = (_a = {}, _a[exports.CalendarView.day] = React__default['default'].createElement(ViewDayOutlined__default['default'], null), _a[exports.CalendarView.threeDay] = React__default['default'].createElement(ViewWeekOutlined__default['default'], null), _a[exports.CalendarView.week] = React__default['default'].createElement(ViewModuleOutlined__default['default'], null), _a[exports.CalendarView.month] = React__default['default'].createElement(ViewComfyOutlined__default['default'], null), _a);
var MobileCalendarHeader = function MobileCalendarHeader(_a) {
  var _b = _a.currentView,
    currentView = _b === void 0 ? exports.CalendarView.day : _b,
    _c = _a.handleTodayClicked,
    handleTodayClicked = _c === void 0 ? function () {} : _c,
    _d = _a.handleViewSelected,
    handleViewSelected = _d === void 0 ? function () {} : _d,
    _e = _a.handleAddEventClicked,
    handleAddEventClicked = _e === void 0 ? function () {} : _e,
    _f = _a.initialDate,
    initialDate = _f === void 0 ? new Date() : _f,
    _g = _a.selectCalendarInitialDate,
    selectCalendarInitialDate = _g === void 0 ? function () {} : _g;
  var classes = useStyles$6();
  var _h = React.useState(false),
    openDatePicker = _h[0],
    setOpenDatePicker = _h[1];
  var _j = React.useState(null),
    anchorEl = _j[0],
    setAnchorEl = _j[1];
  var handleShowMenuClick = function handleShowMenuClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var handleSelection = function handleSelection(view) {
    handleViewSelected(view);
    handleClose();
  };
  var onTodayClick = function onTodayClick() {
    handleTodayClicked();
    handleClose();
  };
  return React__default['default'].createElement(pickers.MuiPickersUtilsProvider, {
    utils: frontend.CustomDateFnsUtils
  }, React__default['default'].createElement(core.Grid, {
    container: true,
    direction: "row",
    justify: "flex-end",
    spacing: 2
  }, React__default['default'].createElement(core.Grid, {
    item: true
  }, React__default['default'].createElement(core.IconButton, {
    className: classes.menuButton,
    color: "secondary",
    onClick: handleShowMenuClick,
    "data-test": "calendar-mobile-header-button-view-toggle"
  }, viewIconMap[currentView]), React__default['default'].createElement(core.Menu, {
    anchorEl: anchorEl,
    onClose: handleClose,
    open: Boolean(anchorEl)
  }, React__default['default'].createElement(core.MenuItem, {
    onClick: onTodayClick
  }, React__default['default'].createElement(core.ListItemIcon, null, React__default['default'].createElement(reactFeather.List, null)), React__default['default'].createElement(core.ListItemText, {
    primaryTypographyProps: {
      variant: "button"
    },
    "data-test": "calendar-mobile-header-button-today"
  }, "Today")), React__default['default'].createElement(core.MenuItem, {
    onClick: function onClick() {
      return setOpenDatePicker(true);
    }
  }, React__default['default'].createElement(core.ListItemIcon, null, React__default['default'].createElement(reactFeather.Calendar, {
    color: "#546E7A",
    size: 20
  })), React__default['default'].createElement(core.ListItemText, {
    primaryTypographyProps: {
      variant: "button"
    },
    "data-test": "calendar-mobile-header-button-jump-date"
  }, dateFns.format(initialDate, "MMMM yyyy"))), React__default['default'].createElement(core.MenuItem, {
    onClick: function onClick() {
      handleSelection(exports.CalendarView.day);
    },
    "data-test": "calendar-mobile-header-button-view-day"
  }, React__default['default'].createElement(core.ListItemIcon, null, React__default['default'].createElement(ViewDayOutlined__default['default'], null)), React__default['default'].createElement(core.ListItemText, {
    primaryTypographyProps: {
      variant: "button"
    }
  }, "Day View")), React__default['default'].createElement(core.MenuItem, {
    onClick: function onClick() {
      handleSelection(exports.CalendarView.threeDay);
    },
    "data-test": "calendar-mobile-header-button-view-threeDay"
  }, React__default['default'].createElement(core.ListItemIcon, null, React__default['default'].createElement(ViewWeekOutlined__default['default'], null)), React__default['default'].createElement(core.ListItemText, {
    primaryTypographyProps: {
      variant: "button"
    }
  }, "3 Day View")), React__default['default'].createElement(core.MenuItem, {
    onClick: function onClick() {
      handleSelection(exports.CalendarView.week);
    },
    "data-test": "calendar-mobile-header-button-view-week"
  }, React__default['default'].createElement(core.ListItemIcon, null, React__default['default'].createElement(ViewModuleOutlined__default['default'], null)), React__default['default'].createElement(core.ListItemText, {
    primaryTypographyProps: {
      variant: "button"
    }
  }, "Week View")))), React__default['default'].createElement(core.Grid, {
    item: true
  }, React__default['default'].createElement(MobileAddButton, {
    onClick: handleAddEventClicked
  })), React__default['default'].createElement(pickers.DatePicker, {
    value: initialDate,
    onChange: selectCalendarInitialDate,
    open: openDatePicker,
    onClose: function onClose() {
      setOpenDatePicker(false);
      handleClose();
    },
    style: {
      display: "none"
    }
  })));
};
var _a$1, _b;
// Function to memoize item data for the list. Needed due to the child component
// of the list not being able to call parent methods through props
var createItemData = memoize__default['default'](function (items, itemClick, today, selection, monthView) {
  return {
    items: items,
    itemClick: itemClick,
    today: today,
    selection: selection,
    monthView: monthView
  };
});
var calculateListWidth = function calculateListWidth(isMobile, isTablet, isDesktop, view) {
  if (isMobile) {
    return 500;
  }
  if (view == "WEEK" || view == "MONTH") {
    if (isTablet) {
      return 800;
    }
    if (isDesktop) {
      return 1500;
    }
  }
  return 900;
};
var getDateColor = function getDateColor(items, index, today, theme) {
  if (items[index].selected) {
    return theme.palette.secondary.main;
  }
  if (index < today) {
    return theme.palette.grey[500];
  }
  return "black";
};
var selection = (_a$1 = {}, _a$1[exports.CalendarView.day] = 1, _a$1[exports.CalendarView.threeDay] = 3, _a$1[exports.CalendarView.week] = 7, _a$1[exports.CalendarView.month] = 1, _a$1);
var offset = (_b = {}, _b[exports.CalendarView.day] = 0, _b[exports.CalendarView.threeDay] = 1, _b[exports.CalendarView.week] = 3, _b[exports.CalendarView.month] = 0, _b);
var useStylesList = styles.makeStyles(function (theme) {
  var _a, _b, _c, _d;
  return styles.createStyles({
    root: (_a = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: theme.spacing(2)
    }, _a[theme.breakpoints.down("md")] = {
      overflow: "hidden",
      marginBottom: 0
    }, _a),
    row: (_b = {
      marginTop: theme.spacing(2),
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      maxWidth: "100%"
    }, _b[theme.breakpoints.down("md")] = {
      marginTop: 0
    }, _b),
    monthName: (_c = {
      fontSize: "0.75rem"
    }, _c[theme.breakpoints.up("sm")] = {
      fontSize: "1.25rem"
    }, _c.fontWeight = "bold", _c),
    list: (_d = {}, _d[theme.breakpoints.down("sm")] = {
      width: 400
    }, _d["&::-webkit-scrollbar"] = {
      display: "none"
    }, _d),
    iconButton: {
      background: "transparent",
      width: 10
    }
  });
});
var useStylesRow = styles.makeStyles(function (theme) {
  var _a;
  return styles.createStyles({
    dateLetter: {
      fontSize: 10,
      color: "#B0BEC5"
    },
    dateButton: {
      fontSize: function fontSize(_a) {
        var monthView = _a.monthView;
        return monthView ? 14 : 20;
      },
      fontWeight: theme.typography.fontWeightMedium,
      color: function color(_a) {
        var items = _a.items,
          index = _a.index,
          today = _a.today;
        return getDateColor(items, index, today, theme);
      }
    },
    monthButton: {
      fontSize: 14,
      marginTop: theme.spacing(7)
    },
    selectedIdentifier: {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: 50,
      width: function width(_a) {
        var monthView = _a.monthView,
          selection = _a.selection;
        if (monthView) {
          return constants.SCROLLER_ITEM_WIDTH * 2;
        }
        if (selection > 1) {
          return constants.SCROLLER_ITEM_WIDTH + 5;
        }
        return constants.SCROLLER_ITEM_WIDTH / 10;
      },
      height: 5,
      marginTop: function marginTop(_a) {
        var monthView = _a.monthView;
        return monthView ? theme.spacing(1) : 0;
      }
    },
    dateBox: (_a = {
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      marginTop: function marginTop(_a) {
        var monthView = _a.monthView;
        return monthView ? theme.spacing(2) : 0;
      },
      width: function width(_a) {
        var monthView = _a.monthView;
        return monthView ? constants.SCROLLER_ITEM_WIDTH * 2 : constants.SCROLLER_ITEM_WIDTH;
      }
    }, _a[theme.breakpoints.up("md")] = {
      margin: "0 10px"
    }, _a)
  });
});
var useWindowSize = function useWindowSize() {
  var _a = React.useState({
      width: window.innerWidth,
      height: window.innerHeight
    }),
    windowSize = _a[0],
    setWindowSize = _a[1];
  React.useEffect(function () {
    var handleResize = function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return windowSize;
};
var Row = function Row(_a) {
  var data = _a.data,
    style = _a.style,
    index = _a.index;
  var items = data.items,
    itemClick = data.itemClick,
    today = data.today,
    selection = data.selection,
    monthView = data.monthView;
  var classes = useStylesRow({
    items: items,
    index: index,
    today: today,
    monthView: monthView,
    selection: selection
  });
  var dateLetter = items[index].date.toLocaleDateString("en-GB", {
    weekday: "long"
  }).charAt(0);
  var entryName = monthView ? items[index].date.toLocaleString("en-GB", {
    month: "long"
  }).toUpperCase() : items[index].date.getDate();
  var selected = items[index].selected;
  var handleClick = function handleClick() {
    itemClick(index);
  };
  return React__default['default'].createElement("div", {
    className: classes.dateBox,
    onClick: handleClick,
    style: style,
    key: index
  }, !monthView && React__default['default'].createElement(core.Typography, {
    className: classes.dateLetter
  }, dateLetter), React__default['default'].createElement(core.Typography, {
    className: classes.dateButton
  }, entryName), selected && React__default['default'].createElement("div", {
    className: classes.selectedIdentifier
  }));
};
var List = function List(_a) {
  var dateData = _a.dateData,
    itemClick = _a.itemClick,
    scrollToIndex = _a.scrollToIndex,
    mobile = _a.mobile,
    selection = _a.selection,
    width = _a.width,
    monthView = _a.monthView,
    currentIndex = _a.currentIndex,
    setCurrentIndex = _a.setCurrentIndex,
    onBackwardClick = _a.onBackwardClick,
    onForwardClick = _a.onForwardClick,
    view = _a.view;
  var classes = useStylesList();
  var listRef = React__default['default'].createRef();
  var items = dateData.entries;
  var today = dateData.entries.findIndex(function (entry) {
    return dateFns.isToday(entry.date);
  });
  var weekView = view === exports.CalendarView.week;
  var monthName = items[currentIndex].date.toLocaleString("en-GB", {
    month: "long",
    year: "numeric"
  });
  var monthNameFormatted = mobile ? monthName.toUpperCase() : monthName;
  var scrollToRow = function scrollToRow(index) {
    var _a;
    (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(index, "center");
  };
  var _onScroll = function onScroll(scroll) {
    if (scroll.scrollOffset % 1 !== 0) return;
    setCurrentIndex(Math.round((scroll.scrollOffset + (width / 2 - constants.SCROLLER_ITEM_WIDTH)) / (monthView ? constants.SCROLLER_ITEM_WIDTH * 2 : constants.SCROLLER_ITEM_WIDTH)));
  };
  var backwardClicked = function backwardClicked() {
    onBackwardClick(currentIndex - selection);
  };
  var forwardClicked = function forwardClicked() {
    onForwardClick(currentIndex + selection);
  };
  React.useEffect(function () {
    scrollToRow(scrollToIndex);
  }, [scrollToIndex, width]);
  var windowSize = useWindowSize();
  React.useEffect(function () {
    scrollToRow(scrollToIndex);
  }, [windowSize]);
  var itemData = createItemData(items, itemClick, today, selection, monthView);
  return React__default['default'].createElement("div", {
    className: classes.root,
    "data-test": "calendar-scroller"
  }, React__default['default'].createElement(core.Typography, {
    className: classes.monthName,
    id: "calendar-scroller-month"
  }, monthNameFormatted), React__default['default'].createElement("div", {
    className: classes.row
  }, weekView && React__default['default'].createElement(core.IconButton, {
    className: classes.iconButton,
    onClick: function onClick() {
      return backwardClicked();
    },
    "aria-label": "delete"
  }, React__default['default'].createElement(NavigateBeforeIcon__default['default'], null)), React__default['default'].createElement(reactWindow.FixedSizeList, {
    className: classes.list,
    onScroll: function onScroll(scroll) {
      return _onScroll(scroll);
    },
    itemData: itemData,
    ref: listRef,
    layout: "horizontal",
    height: constants.SCROLLER_ITEM_WIDTH,
    width: width,
    itemSize: monthView ? constants.SCROLLER_ITEM_WIDTH * 2 : constants.SCROLLER_ITEM_WIDTH,
    itemCount: items.length
  }, Row), weekView && React__default['default'].createElement(core.IconButton, {
    className: classes.iconButton,
    onClick: function onClick() {
      return forwardClicked();
    },
    "aria-label": "delete"
  }, React__default['default'].createElement(NavigateNextIcon__default['default'], null))));
};
var Scroller = function Scroller(_a) {
  var view = _a.view,
    dateData = _a.dateData,
    scrollToIndex = _a.scrollToIndex,
    currentIndex = _a.currentIndex,
    setCurrentIndex = _a.setCurrentIndex,
    onDateClick = _a.onDateClick,
    onBackwardClick = _a.onBackwardClick,
    onForwardClick = _a.onForwardClick,
    monthView = _a.monthView,
    width = _a.width;
  var theme = core.useTheme();
  var isSm = core.useMediaQuery(theme.breakpoints.down("sm"));
  var isMd = core.useMediaQuery(theme.breakpoints.down("md"));
  var isLg = core.useMediaQuery(theme.breakpoints.up("lg"));
  var listWidth = width || calculateListWidth(isSm, isMd, isLg, view);
  if (!scrollToIndex || !dateData) return null;
  return React__default['default'].createElement(List, {
    scrollToIndex: scrollToIndex,
    dateData: dateData,
    width: listWidth,
    onForwardClick: onForwardClick,
    onBackwardClick: onBackwardClick,
    mobile: core.useMediaQuery(theme.breakpoints.down("sm")),
    selection: selection[view],
    monthView: monthView,
    currentIndex: currentIndex,
    setCurrentIndex: setCurrentIndex,
    itemClick: onDateClick,
    view: view
  });
};
var _a$2, _b$1;
var buildTravelTimeEvent = function buildTravelTimeEvent(lesson) {
  var id = lesson.id,
    endDateTime = lesson.endDateTime,
    travelTimeInMinutes = lesson.travelTimeInMinutes;
  return {
    title: undefined,
    start: endDateTime,
    end: dateFns.addMinutes(new Date(endDateTime), travelTimeInMinutes),
    extendedProps: {
      id: id + "-travelTime",
      eventType: models.EventType.Travel
    }
  };
};
var getLessonEventType = function getLessonEventType(lesson) {
  if (lesson.status === models.LessonStatus.Cancelled) return models.EventType.Cancelled;
  if (lesson.newLearner) return models.EventType.NewLesson;
  if (lesson.paid) return models.EventType.PaidLesson;
  return models.EventType.UnpaidLesson;
};
var hasTravelTime = function hasTravelTime(lesson) {
  var __typename = lesson.__typename,
    travelTimeInMinutes = lesson.travelTimeInMinutes;
  return __typename === "Lesson" && travelTimeInMinutes > 0;
};
var buildLessonEvent = function buildLessonEvent(lesson) {
  var _a, _b, _c, _d, _e;
  var lessonEventType = getLessonEventType(lesson);
  var title = frontend.formatTime(new Date(lesson.startDateTime));
  var addressSource = ((_a = lesson.learner) === null || _a === void 0 ? void 0 : _a.pickupAddress) || ((_b = lesson.learner) === null || _b === void 0 ? void 0 : _b.address);
  return {
    title: title,
    start: lesson.startDateTime,
    end: lesson.endDateTime,
    extendedProps: {
      id: lesson.id,
      eventType: lessonEventType,
      learnerSource: lesson.learner.sourcedBy,
      learnerFullName: ((_c = lesson.learner) === null || _c === void 0 ? void 0 : _c.name.firstName) + " " + ((_d = lesson.learner) === null || _d === void 0 ? void 0 : _d.name.lastName),
      test: (_e = lesson.test) !== null && _e !== void 0 ? _e : false,
      address: {
        line1: addressSource === null || addressSource === void 0 ? void 0 : addressSource.line1,
        line2: addressSource === null || addressSource === void 0 ? void 0 : addressSource.line2,
        postcode: addressSource === null || addressSource === void 0 ? void 0 : addressSource.postcode
      }
    }
  };
};
var truncateTimeOffTitle = function truncateTimeOffTitle(title) {
  return title.length <= 36 ? title : title.substring(0, 36).trim() + "\u2026";
};
var getTitleForTimeOff = function getTitleForTimeOff(timeOff) {
  return timeOff.notes ? truncateTimeOffTitle(timeOff.notes) : "Unavailable";
};
var buildTimeOffEvent = function buildTimeOffEvent(timeOff) {
  var startDateTime = timeOff.startDateTime,
    endDateTime = timeOff.endDateTime;
  var startDate = new Date(startDateTime);
  var endDate = new Date(endDateTime);
  var title = getTitleForTimeOff(timeOff);
  return {
    title: title,
    start: startDate,
    end: endDate,
    extendedProps: {
      id: timeOff.id,
      eventType: models.EventType.Unavailable,
      repeatFrequency: timeOff.repeatFrequency
    }
  };
};
var mapEventsToCalendarEvents = function mapEventsToCalendarEvents(events) {
  var result = events.reduce(function (newEvents, calendarEvent) {
    if (calendarEvent.__typename === "Lesson") {
      var lessonEvent = buildLessonEvent(calendarEvent);
      newEvents.push(lessonEvent);
      var addTravelTime = hasTravelTime(calendarEvent);
      if (addTravelTime) {
        var travelTimeEvent = buildTravelTimeEvent(calendarEvent);
        newEvents.push(travelTimeEvent);
      }
    }
    if (calendarEvent.__typename === "TimeOff") {
      var timeOffEvent = buildTimeOffEvent(calendarEvent);
      newEvents.push(timeOffEvent);
    }
    return newEvents;
  }, []);
  return result;
};
/**
 * determine earliest possible event slot for date
 * @param date
 * @param slotMinTimeHours
 */
var earliestEventTime = function earliestEventTime(date, slotMinTimeHours) {
  var startTimeOffset = dateFns.format(date, "xx");
  var hours = ("0" + slotMinTimeHours).slice(-2);
  return new Date(dateFns.format(date, "yyyy-MM-dd") + "T" + hours + ":00:00" + startTimeOffset);
};
/**
 * determine latest possible event slot for date
 * @param date
 * @param slotMaxTimeHours
 */
var latestEventTime = function latestEventTime(date, slotMaxTimeHours) {
  var startTimeOffset = dateFns.format(date, "xx");
  var hours = ("0" + (slotMaxTimeHours - 1)).slice(-2);
  return new Date(dateFns.format(date, "yyyy-MM-dd") + "T" + hours + ":59:59" + startTimeOffset);
};
var generateDays = function generateDays(selection, providedDate) {
  if (providedDate === void 0) {
    providedDate = new Date();
  }
  var date = new Date(providedDate);
  var todaysDate = new Date(providedDate);
  date.setFullYear(date.getFullYear() - 2);
  var endDate = new Date(date.getFullYear() + 4, date.getMonth(), date.getDate());
  var days = [];
  var today = 0;
  while (date.toDateString() !== endDate.toDateString()) {
    if (date.toDateString() === todaysDate.toDateString()) {
      days.push({
        date: new Date(date),
        selected: true
      });
      today = days.length - 1;
      date.setDate(date.getDate() + 1);
      if (selection == 3 || selection == 7) {
        ___default['default'].times(selection - 1, function () {
          days.push({
            date: new Date(date),
            selected: true
          });
          date.setDate(date.getDate() + 1);
        });
      }
    } else {
      days.push({
        date: new Date(date),
        selected: false
      });
      date.setDate(date.getDate() + 1);
    }
  }
  return {
    entries: days,
    current: today
  };
};
// Similar function to generateDays, slightly simpler in that it only generates months
// Basically generates a Date obj for the first of every month and pushes to an array
// Also finds the index of todays month, in order to assign it as the default selected date
var generateMonths = function generateMonths(date) {
  if (date === void 0) {
    date = new Date();
  }
  var months = [];
  var now = new Date(date);
  var year = now.getFullYear() - 2;
  var thisMonth = 0;
  new Array(constants.SCROLLER_MONTHS_RANGE).fill(1).forEach(function (_, index) {
    if (new Date(year, index, 1).getMonth() === new Date(date).getMonth() && new Date(year, index, 1).getFullYear() === new Date(date).getFullYear()) {
      months.push({
        date: new Date(year, index, 1),
        selected: true
      });
      thisMonth = months.length - 1;
    } else {
      months.push({
        date: new Date(year, index, 1),
        selected: false
      });
    }
  });
  return {
    entries: months,
    current: thisMonth
  };
};
// Function to memoize item data for the list. Needed due to the child component
// of the list not being able to call parent methods through props
var createItemData$1 = memoize__default['default'](function (items, itemClick, today, selection, monthView) {
  return {
    items: items,
    itemClick: itemClick,
    today: today,
    selection: selection,
    monthView: monthView
  };
});
var calculateListWidth$1 = function calculateListWidth$1(isMobile, isTablet, isDesktop, view) {
  if (isMobile) {
    return 500;
  }
  if (view == "WEEK" || view == "MONTH") {
    if (isTablet) {
      return 800;
    }
    if (isDesktop) {
      return 1500;
    }
  }
  return 900;
};
var getDateColor$1 = function getDateColor$1(items, index, today, theme) {
  if (items[index].selected) {
    return theme.palette.secondary.main;
  }
  if (index < today) {
    return theme.palette.grey[500];
  }
  return "black";
};
var selection$1 = (_a$2 = {}, _a$2[models.CalendarView.day] = 1, _a$2[models.CalendarView.threeDay] = 3, _a$2[models.CalendarView.week] = 7, _a$2[models.CalendarView.month] = 1, _a$2);
var offset$1 = (_b$1 = {}, _b$1[models.CalendarView.day] = 0, _b$1[models.CalendarView.threeDay] = 1, _b$1[models.CalendarView.week] = 3, _b$1[models.CalendarView.month] = 0, _b$1);
exports.DayHeader = DayHeader;
exports.DayView = DayView;
exports.DesktopHeader = DesktopCalendarHeader;
exports.Event = Event$1;
exports.Legend = Legend;
exports.MobileHeader = MobileCalendarHeader;
exports.Scroller = Scroller;
exports.SlotLabel = SlotLabel;
exports.buildLessonEvent = buildLessonEvent;
exports.buildTimeOffEvent = buildTimeOffEvent;
exports.buildTravelTimeEvent = buildTravelTimeEvent;
exports.calculateListWidth = calculateListWidth$1;
exports.createItemData = createItemData$1;
exports.earliestEventTime = earliestEventTime;
exports.generateDays = generateDays;
exports.generateMonths = generateMonths;
exports.getDateColor = getDateColor$1;
exports.getLessonEventType = getLessonEventType;
exports.getTitleForTimeOff = getTitleForTimeOff;
exports.hasTravelTime = hasTravelTime;
exports.latestEventTime = latestEventTime;
exports.mapEventsToCalendarEvents = mapEventsToCalendarEvents;
exports.offset = offset$1;
exports.selection = selection$1;
exports.truncateTimeOffTitle = truncateTimeOffTitle;